import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { AddressViewComponent } from '@shared/components/address-view/address-view.component';

@Component({
  selector: 'address-view',
  template: `
    <app-address-view
      *ngIf="model && model[props.addressKey]"
      [legend]="props.legend | translate"
      [address]="model[props.addressKey]">
    </app-address-view>
  `,
  imports: [CommonModule, AddressViewComponent, TranslateModule]
})
export class FormlyAddressViewTypeComponent extends FieldType {

}
